var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.content.content.includes('vimeo') ? 'VimeoComponent' : 'VideohubComponent',{key:_vm.content.id,tag:"component"})
}
var staticRenderFns = []

export { render, staticRenderFns }